<template>
  <div class='kxUnbind'>
      <div class="kxCon" v-if="studentEsn">
         <!--  <p class="title">教育数字身份</p>
          <div class="qcode">
            <img :src='codeUrl' />
          </div>
          <span class="refresh" @click="getstudentEsn"><van-icon name="replay" />&nbsp;刷新</span> -->
          <div class="flex-between borders">
            <span>已完成可信身份认证</span>
            <div class="btn" @click="delectCon(1)">取消认证</div>
          </div>
          <div class="con">
              <p class=" flex-between"><span class="color3">姓名</span><span>{{eduCode.name}}</span></p>
              <p class=" flex-between"><span class="color3">学校</span><span>{{eduCode.orgName}}</span></p>
          </div>
      </div>
    
  </div>
</template>
<script>
import {getEduCode,trustedIdentityUnbinding,deleteStudent,queryIdentityByUserId} from '@/api/api.mine.js';
// import QRCode from 'qrcode';
export default {
    data() {
      return {
        details:'',
        studentEsn:this.$route.query.Esn,//安全码
        eduCode:'',
        sex:['','男','女'],
        // codeUrl:'',
      }
    },
    created(){
     //获取可信身份基础数据
         this.getstudentEsn();
     
    },  
    methods: {
      getstudentEsn(){
        getEduCode({studentEsn:this.studentEsn}).then(res=>{
          this.eduCode=res.data.data;
        })
      },
      // getQRCode(){
      //   QRCode.toDataURL(
      //     this.eduCode,{
      //       width:240,
      //       height:240,
      //       margin:6
      //     }
      //   ).then((url)=>{
      //     this.codeUrl=url;
      //   }).catch((e)=>{

      //   })
      // },
      delectCon(type){
        let str='确定要取消当前数字身份认证吗？';
         this.$dialog.confirm({
            message: str,
            confirmButtonColor:'#2403df',
            confirmButtonText:'确定'
         }).then(() => {
          if(type==1){//解绑可信身份
            trustedIdentityUnbinding({
                  studentId:this.loginUser.studentId
              }).then((data) => {
                if (data && data.result) {
                   if(pageBackUrl){
                     location.href=pageBackUrl;
                   }else{
                     this.$router.go(-1);
                   }
                }
              })
          }
              
         }).catch(() => {
          // on cancel
         });
       },
       
    },
  }
</script>
<style lang="scss" >
.kxUnbind{
  font-size:.15rem;
  margin:.15rem;
  color: #666;
  .kxCon,.con{
      line-height: .36rem;
      padding:.2rem;
      border-radius: .1rem;
      background: #fff;
      margin-bottom: .15rem;
  }
  .title{
    color:#333;
    font-size: .17rem;
  }
  .btn{
    line-height: .3rem;
    color:#fff;
    border-radius:15px;
    background: #2287FE;
    font-size: .15rem;
    width: .9rem;
    text-align: center;
  }
  .refresh{
    border-radius: 15px;
    border:1px solid #D9D9D9;
    padding:.04rem .1rem;
    display: inline-block;
    margin-bottom: .25rem;
  }
  .borders{
    margin-bottom: .2rem;
    border-bottom: 1px solid #ECECEC;
    padding-bottom: .12rem;
  }
  .con{
    .color3{
      color:#333;
    }
  }
  .bindBtn{
    margin: .2rem auto;

  }
}

</style>